import { render, staticRenderFns } from "./EntidadesTable.vue?vue&type=template&id=31957a65&"
import script from "./EntidadesTable.vue?vue&type=script&lang=js&"
export * from "./EntidadesTable.vue?vue&type=script&lang=js&"
import style0 from "./EntidadesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VSimpleTable})
